<template>
  <div class="p-4">
    <survey-container />
  </div>
</template>

<script>
import SurveyContainer from '@/components/survey/SurveyContainer'

export default {
  components: {
    SurveyContainer
  },
  mounted () {
    this.$store.dispatch('survey/init')
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'thank-you') {
      next()
    } else {
      const options = {
        title: 'You haven\'t finished the survey',
        cancelLabel: 'Finish survey',
        okLabel: 'Leave survey'
      }
      this.$dialogs.confirm('You haven\'t finished filling out the survey, leaving will lose your changes.', options)
        .then(res => {
          if (res.ok) {
            next()
          } else {
            next(false)
          }
        })
    }
  }
}
</script>
